import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import api from "@/lib/api";

/**
 * Horizontal category quick-nav. Used on CategoryPage and ArticlePage so
 * readers can jump between categories without going back to the home.
 */
export default function CategoryNav({ current }) {
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/public/categories")
      .then((r) => setCats(r.data || []))
      .catch(() => setCats([]));
  }, []);

  if (!cats.length) return null;

  return (
    <div className="bg-white border-b border-[#0F0F0F]/15 sticky top-0 z-30" data-testid="category-nav">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 overflow-x-auto hide-scrollbar">
        <div className="flex items-center gap-1 py-2.5">
          <NavLink
            to="/"
            className="shrink-0 px-3 py-1.5 text-[12px] uppercase tracking-[0.16em] text-[#4A4A4A] hover:text-[#D92525]"
            data-testid="catnav-home"
          >
            होम
          </NavLink>
          <span className="text-[#0F0F0F]/20">|</span>
          {cats.map((c) => (
            c.external_url ? (
              <a
                key={c.key}
                href={c.external_url}
                target="_blank"
                rel="noreferrer noopener"
                data-testid={`catnav-${c.key}`}
                className="shrink-0 px-3 py-1.5 text-[12px] uppercase tracking-[0.16em] whitespace-nowrap text-[#0F0F0F] hover:text-[#D92525] transition-colors"
              >
                {c.label} ↗
              </a>
            ) : c.dropdown ? (
              <div key={c.key} className="relative group shrink-0" data-testid={`catnav-${c.key}`}>
                <button className="px-3 py-1.5 text-[12px] uppercase tracking-[0.16em] whitespace-nowrap text-[#0F0F0F] hover:text-[#D92525] transition-colors">
                  {c.label} ▾
                </button>
                <div className="absolute left-0 top-full min-w-[160px] bg-white border border-[#0F0F0F] shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible focus-within:opacity-100 focus-within:visible transition-all z-50">
                  {c.dropdown.map((d) => (
                    <a
                      key={d.url}
                      href={d.url}
                      target="_blank"
                      rel="noreferrer noopener"
                      data-testid={`catnav-${c.key}-${d.label.replace(/\s+/g, "-")}`}
                      className="block px-4 py-2 text-[11px] uppercase tracking-[0.14em] hover:bg-[#F4F4F0] hover:text-[#D92525] border-b border-[#0F0F0F]/10 last:border-0"
                    >
                      {d.label} ↗
                    </a>
                  ))}
                </div>
              </div>
            ) : (
              <NavLink
                key={c.key}
                to={`/category/${c.key}`}
                data-testid={`catnav-${c.key}`}
                className={
                  (c.key === current
                    ? "text-[#D92525] font-bold border-b-2 border-[#D92525] "
                    : "text-[#0F0F0F] hover:text-[#D92525] ") +
                  "shrink-0 px-3 py-1.5 text-[12px] uppercase tracking-[0.16em] whitespace-nowrap transition-colors"
                }
              >
                {c.label}
              </NavLink>
            )
          ))}
        </div>
      </div>
    </div>
  );
}
